import { render, staticRenderFns } from "./ItemDisplay.vue?vue&type=template&id=dfe83b3a&scoped=true"
import script from "./ItemDisplay.vue?vue&type=script&lang=js"
export * from "./ItemDisplay.vue?vue&type=script&lang=js"
import style0 from "./ItemDisplay.vue?vue&type=style&index=0&id=dfe83b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe83b3a",
  null
  
)

export default component.exports